import { render, staticRenderFns } from "./OnlineResearchDetail.vue?vue&type=template&id=4c69d1b6&scoped=true&"
import script from "./OnlineResearchDetail.vue?vue&type=script&lang=js&"
export * from "./OnlineResearchDetail.vue?vue&type=script&lang=js&"
import style0 from "./OnlineResearchDetail.vue?vue&type=style&index=0&id=4c69d1b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c69d1b6",
  null
  
)

export default component.exports